import React from 'react';
import PropTypes from 'prop-types';
import { FieldSet } from '../../elements';

const HighSchoolTranscriptSection = ({
  checkData,
  reasons,
  onChange,
  saving,
}) => {
  const hasTranscript = checkData.has_transcript;
  const selectedReasonId = checkData.reason || null;
  const otherReason = checkData.other_reason || '';

  const handleHasTranscriptChange = (value) => {
    onChange({ ...checkData, has_transcript: value, reason: null, other_reason: '' });
  };

  const handleReasonChange = (reasonId) => {
    onChange({ ...checkData, reason: reasonId, other_reason: '' });
  };

  const handleOtherReasonChange = (e) => {
    onChange({ ...checkData, reason: null, other_reason: e.target.value });
  };

  const noReasonFilled =
    hasTranscript === false &&
    !selectedReasonId &&
    !otherReason.trim();

  return (
    <>
      <FieldSet title="Histórico Escolar Ensino Médio" />
      <div className="row mb-3">
        <div className="col-12">
          <div className="d-flex align-items-center mb-2">
            <label className="mr-4 mb-0 font-weight-bold">
              Possui Histórico Escolar do Ensino Médio?
            </label>
            <div className="d-flex">
              <label className="mr-3 mb-0 d-flex align-items-center" style={{ cursor: 'pointer' }}>
                <input
                  type="radio"
                  name="has_transcript"
                  value="sim"
                  checked={hasTranscript === true}
                  onChange={() => handleHasTranscriptChange(true)}
                  className="mr-1"
                  disabled={saving}
                />
                SIM
              </label>
              <label className="mb-0 d-flex align-items-center" style={{ cursor: 'pointer' }}>
                <input
                  type="radio"
                  name="has_transcript"
                  value="nao"
                  checked={hasTranscript === false}
                  onChange={() => handleHasTranscriptChange(false)}
                  className="mr-1"
                  disabled={saving}
                />
                NÃO
              </label>
            </div>
          </div>

          {hasTranscript === false && (
            <div className="mt-2 pl-2 border-left" style={{ borderLeftColor: '#ccc', borderLeftWidth: 3 }}>
              <p className="mb-2 font-weight-bold text-muted" style={{ fontSize: 14 }}>
                Motivo:
              </p>
              {reasons.map((r) => (
                <label
                  key={r.id}
                  className="d-block mb-1"
                  style={{ cursor: 'pointer', fontWeight: 'normal' }}
                >
                  <input
                    type="radio"
                    name="hs_reason"
                    value={r.id}
                    checked={selectedReasonId === r.id}
                    onChange={() => handleReasonChange(r.id)}
                    className="mr-2"
                    disabled={saving}
                  />
                  {r.description}
                </label>
              ))}
              <div className="mt-2">
                <label className="d-block mb-1" style={{ fontWeight: 'normal' }}>
                  <input
                    type="radio"
                    name="hs_reason"
                    value="other"
                    checked={!selectedReasonId && otherReason.length > 0}
                    onChange={() => onChange({ ...checkData, reason: null })}
                    className="mr-2"
                    disabled={saving}
                  />
                  Outro Motivo:
                </label>
                <textarea
                  className="form-control"
                  rows={3}
                  placeholder="Descreva o motivo..."
                  value={otherReason}
                  onChange={handleOtherReasonChange}
                  disabled={saving || !!selectedReasonId}
                  style={{ resize: 'vertical' }}
                />
              </div>
              {noReasonFilled && (
                <small className="text-danger">
                  Selecione um motivo ou descreva outro motivo.
                </small>
              )}
            </div>
          )}

          {checkData.analyzed_by_name && (
            <small className="text-muted d-block mt-2">
              Analisado por {checkData.analyzed_by_name} em{' '}
              {checkData.analyzed_at
                ? new Date(checkData.analyzed_at).toLocaleString('pt-BR')
                : ''}
            </small>
          )}
        </div>
      </div>
    </>
  );
};

HighSchoolTranscriptSection.propTypes = {
  checkData: PropTypes.shape({
    has_transcript: PropTypes.bool,
    reason: PropTypes.number,
    other_reason: PropTypes.string,
    analyzed_by_name: PropTypes.string,
    analyzed_at: PropTypes.string,
  }).isRequired,
  reasons: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.number, description: PropTypes.string })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  saving: PropTypes.bool,
};

HighSchoolTranscriptSection.defaultProps = {
  saving: false,
};

export default HighSchoolTranscriptSection;
